export enum MetricTypes {
  KG = 1,
  PIECES = 2,
}
